import {css} from 'emotion'
import {Colors, Label, SliderContent, Easings} from './..'

const defaultDropDown = (open, dark) => ({
  position: 'relative',
  '.dropdown': {
    '&-list':{
      position: 'relative',
      zIndex: 10,
      width: '100%',
      maxHeight: 200,
      overflow: 'auto',
      transform: `scaleY(${ open ? 1 : 0})`,
      transformOrigin: 'top center',
      visibility: open ? 'visible' : 'hidden',
      transition: `transform 300ms ${Easings.customEase} ${ open ? 0 : 300}ms, visibility 0ms ease ${ open ? 0 : 600}ms`,
      willChange: 'transform, visibility',
      display: open ? 'block' : 'none',
      '@media (min-width: 1024px)':{
        position: 'absolute',
        bottom: 0,
        left: 0,
        display: 'block',
        transform: `translateY(100%) scaleY(${ open ? 1 : 0})`,
      },
      '& > li': {
        padding: '0.5rem 0',
        textTransform: 'uppercase',
        cursor: 'pointer',
        opacity: open ? 1 : 0,
        transition: `opacity 300ms ease ${ open ? 300 : 0}ms`,
      }
    },
    '&-label':{
      position: 'relative',
      zIndex: 1,
      width: '100%',
      background: 'none',
      border: 0,
      cursor: 'pointer',
      textAlign: 'center',
      padding: '1rem 0',
      color: dark ? 'white' : Colors.grey,
      '@media (min-width: 1024px)': {
        padding: 0,
        color: 'black',
      },
      '& > svg': {
        position: 'absolute',
        transform: `rotate(${ open ? -90 : 90}deg)`,
        fill: Colors.mediumGrey,
        top: '50%',
        right: 0,
        transform: `rotate(${ open ? -90 : 90}deg) translateX(${open ? 50 : -50}%)`,
        marginLeft: 0,
      }
    }
  },
})

export const SelectDropdownStyle = (open, label, dark) => css({
    ...defaultDropDown(open, dark),
}, {
  '.dropdown': {
    '&-list':{
      background: 'white',
      boxShadow: `0 5px 20px 0 ${Colors.shadow}`,
      '& > li': {
        ...SliderContent,
        paddingLeft: '1rem',
      }
    },
    '&-label':{
      ...Label,
      margin: '0.3125rem 0px',
      padding: '0.3125rem 0',
      borderBottom: `1px solid ${Colors.lightGrey}`,
      color: label ? 'black' : Colors.lightGrey,
      textAlign: 'left',
      '@media (min-width: 1024px)': {
        textAlign: 'center',
      }
    }
  },
  '@media (min-width: 1024px)': {
    '.dropdown': {
      '&-label': {
        padding: '0.625rem 0px',
      },
    },
  },
})

export const FilterDropdownStyle = (open, dark) => css({ 
  ...defaultDropDown(open, dark)
}, {
  '.dropdown': {
    '&-list':{
      background: 'white',
      padding: '1rem',
      width: '100%',
      transform: `scaleY(${ open ? 1 : 0})`,
      '@media (min-width: 1024px)': {
        width: 200,
        transform: `translateY(100%) translateY(10px) scaleY(${ open ? 1 : 0})`,
        boxShadow: `0 5px 20px 0 ${Colors.shadow}`,
      },
      ' & > div': {
        opacity: open ? 1 : 0,
        transition: `opacity 300ms ease ${ open ? 300 : 0}ms`,
      }
    }
  }
})


// WEBPACK FOOTER //
// ./src/styles/components/dropdown.js